import React from "react";
import { HashRouter as Router } from "react-router-dom";
import "../styles/Cavs.css";

import Routes from "../components/routes/Routes";
import { ProvideOrganization } from "../hooks/useOrganization";
import { ProvideAuth } from "../hooks/usehooks.com/use-auth";

export default function App() {
  return (
    <Router>
      <ProvideAuth>
        <ProvideOrganization>
          <Routes />
        </ProvideOrganization>
      </ProvideAuth>
    </Router>
  );
}
